import { t as translateDate } from './translate-date.js';
import { U as Url } from './url.min.js';
import './index2.js';

/**
 * **Omnibees**
 *
 * @exports bs_86
 * @category engines
 */
function factory({ window, document, thn, }) {
    const engine = {};
    engine._mobileGetCurrency = function () {
        let result;
        try {
            const currencyJson = JSON.parse(window.sessionStorage.getItem('BE_MOBILE.currency'));
            result = thn.getCurrencyCode(currencyJson.data.Symbol);
        }
        catch (err) {
            thn.logger.debug(err, '--- Error Getting Currency ---');
        }
        return result;
    };
    /**
       * @memberOf module:bs_86
       * @see {@link prestart}
       *
       * @param {object} ctx - The context object.
       */
    engine.boot = function boot() {
        const $ = window.jQuery;
        if ($ && window.location.hostname === 'm-reservations.omnibees.com') { // other mobile version
            // unlisten to ensure it is not added multiple times
            $(document).off('change', 'select#lang', thn.languageCheck);
            // listen to lang change
            $(document).on('change', 'select#lang', thn.languageCheck);
            thn.shutdown(function () {
                $(document).off('change', 'select#lang', thn.languageCheck);
            });
        }
        else if ($ && window.location.hostname === 'myreservations.omnibees.com') { // Desktop
            // When visiting the Calendar directly from the Home page, we must detect the page change to R&R
            const $loader = $('#preloader');
            if (!thn.omnibeesPageUpdater && $loader && $loader.length) {
                thn.omnibeesPageUpdater = thn.debounce(function thnOmnibeesUpdater() {
                    thn.logger.debug('Page check!');
                    thn.pageCheck();
                }, 600);
                // observe preloader just for attr changes
                thn.observeDom($loader.get(0), thn.omnibeesPageUpdater, {
                    childList: false,
                    subtree: false,
                    characterData: false,
                    attributes: true,
                    attributeFilter: ['class', 'style'],
                });
                thn.pageUnload(function () {
                    thn.stopObserveDom($loader.get(0), thn.omnibeesPageUpdater);
                    delete thn.omnibeesPageUpdater;
                });
            }
        }
    };
    /**
       * @memberOf module:bs_86
       * @see {@link language_check}
       *
       * @param {object} ctx - The context object.
       */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            thn.domReady().then(function () {
                let aux;
                if (window.location.hostname.indexOf('mobilereservations.') === 0) { // Mobile
                    try {
                        const langJson = JSON.parse(window.sessionStorage.getItem('BE_MOBILE.language'));
                        aux = langJson.data.Code.substr(0, 2);
                        if (aux && ctx.langs.test(aux)) {
                            resolve(aux);
                            return;
                        }
                    }
                    catch (err) {
                        thn.logger.debug(err, '--- Error Getting Lang ---');
                    }
                }
                else if (window.location.hostname === 'm-reservations.omnibees.com') { // other mobile version
                    const langEl = document.querySelector('#lang');
                    if (langEl) {
                        aux = langEl.options[langEl.selectedIndex].value.slice(0, 2);
                        if (aux && ctx.langs.test(aux)) {
                            resolve(aux);
                            return;
                        }
                    }
                }
                else { // Desktop
                    const $ = window.jQuery;
                    if ($) {
                        const obLanguages = {
                            1: 'en',
                            3: 'es',
                            4: 'pt',
                            8: 'pt',
                        };
                        // Nacional Inn
                        if (thn.data.accountUserId === 1032837) {
                            resolve('pt'); // fixed
                            return;
                        }
                        // Hoteles Mocawa
                        if (thn.data.accountUserId === 1035502 && window.location.hostname.match(/hotelmocawa/)) {
                            resolve('es');
                            return;
                        }
                        // vivaz cataraz 1015281
                        // http://www.vivazcataratas.com.br
                        if (thn.data.propertyId === 1015281 && window.location.hostname.match(/vivazcataratas.com.br/)) {
                            const langEl = document.querySelector('#language-selector .language-selector-toggle span');
                            if (langEl) {
                                const langCode = langEl.innerHTML.split('-')[0];
                                aux = langCode.toLowerCase();
                                resolve(aux);
                                return;
                            }
                        }
                        // allurehotels.com
                        if (thn.data.accountUserId === 1034171 && window.location.hostname === 'www.allurehotels.com') {
                            const langEl = document.getElementById('txtidioma');
                            if (langEl) {
                                aux = langEl.textContent.toLowerCase();
                                if (aux && ctx.langs.test(aux)) {
                                    resolve(aux);
                                    return;
                                }
                            }
                        }
                        // http://hotelcolonialfoz.com.br/
                        if (thn.data.propertyId === 1014425
                            && window.location.hostname.match(new RegExp('(hotelcolonialfoz.)', 'i'))) {
                            if ($ && $.fn.datepicker && $.fn.datepicker.dates) {
                                aux = Object.keys($.fn.datepicker.dates);
                                if (aux && aux.length && aux.length === 2 && ctx.langs.test(aux[1])) {
                                    resolve(aux[1]);
                                    return;
                                }
                            }
                        }
                        // Brisa Hotéis (not in the BS)
                        if (thn.data.accountUserId === 1033612
                            && window.location.hostname.substr(-13) !== '.omnibees.com') {
                            resolve('pt');
                            return;
                        }
                        if (thn.data.propertyId === 1015901 && window.location.hostname === 'www.recantocataratasresort.com.br') {
                            const langEl = document.querySelector('#resort');
                            const languages = {
                                'O Resort': 'pt',
                                'The Resort': 'en',
                                'El Resort': 'es',
                            };
                            if (langEl) {
                                aux = languages[langEl.textContent];
                                resolve(aux);
                                return;
                            }
                        }
                        // capilladelmar.com
                        if (thn.data.accountUserId === 1032966 && window.location.hostname.match(/capilladelmar/)) {
                            const selectLang = document.querySelector('.menu-item-language select');
                            const lang = selectLang && selectLang.options[selectLang.selectedIndex];
                            aux = lang && lang.value && lang.value.substr(0, 2);
                            if (aux && ctx.langs.test(aux)) {
                                resolve(aux);
                                return;
                            }
                        }
                        // Elcielo Hotel
                        if (thn.data.propertyId === 1035158 && window.location.hostname.match(/www.elcielohotel.com/)) {
                            // eslint-disable-next-line no-unsafe-optional-chaining
                            const [langCode] = document.querySelector('.w-nav-brand')?.href?.split('https://www.elcielohotel.com/').filter(Boolean);
                            const lang = langCode || 'es';
                            if (lang && ctx.langs.test(lang)) {
                                resolve(lang);
                                return;
                            }
                        }
                        // Desktop navigation
                        const langEl = document.querySelector && document.querySelector('#navigation .language img');
                        if (langEl) {
                            aux = langEl.title.substr(0, 2).toLowerCase();
                            if (aux && ctx.langs.test(aux)) {
                                resolve(aux);
                                return;
                            }
                        }
                        // SERHS villas da pipa hotel
                        if (thn.data.accountUserId === 1031919 && !window.location.hostname.match(/book.omnibees/)) {
                            // The language via pathname
                            const langUrl = window.location.pathname.match(/^\/(\w{2})/);
                            const language = langUrl?.[1];
                            if (language && ctx.langs.test(language)) {
                                resolve(language);
                                return;
                            }
                            resolve('pt');
                            return;
                        }
                        // priorty: BS select, URL param, HTML lang, default
                        aux = (obLanguages[aux] || thn.parseUrlParameter('lang') || ctx.getHtmlLang() || window.body?.lang || '').substr(0, 2);
                        if (aux && ctx.langs.test(aux)) {
                            // Confiance Hotéis, resolve with 'pt' when their pages are on 'br'
                            if (thn.data.accountUserId === 1033456 && aux === 'br') {
                                aux = 'pt';
                            }
                            resolve(aux);
                            return;
                        }
                        // Get language from the HTML xml:lang tag
                        aux = document.getElementsByTagName('html')[0].getAttribute('xml:lang');
                        if (aux && ctx.langs.test(aux)) {
                            resolve(aux);
                            return;
                        }
                    }
                    // hotelsuitecomfort.com/
                    if (thn.data.accountUserId === 1035958 && window.location.hostname === 'www.hotelsuitecomfort.com') {
                        // The lang_switcher doesn't work correctly, we need to check the language via pathname
                        const langCode = window.location.pathname.match(/^\/(\w{2})/);
                        // use 'es' as fallback in this case
                        aux = !thn.empty(langCode) ? langCode[1] : 'es';
                        if (aux && ctx.langs.test(aux)) {
                            resolve(aux);
                            return;
                        }
                    }
                    resolve('en');
                    return;
                }
                reject('no_language');
            });
        });
    };
    /**
       * Forbid execution on:
       * - Holtel costa mar https://www.hotelcostamar.com.br/checkin/ckform.php
       *
       * @memberOf module:bs_86
       * @see {@link allowed_location}
       *
       * @param {object} ctx - The context object.
       */
    engine.allowedLocation = function allowedLocation() {
        var isAllowedLocation = true;
        // Hotel Costa mar
        if ([1014476, 1014473].includes(thn.data.propertyId)
            && window.location.pathname.match(new RegExp('/checkin/ckform.php', 'i'))) {
            isAllowedLocation = false;
        }
        return isAllowedLocation;
    };
    /**
       * @memberOf module:bs_86
       * @see {@link onStateChange}
       *
       * @param {object} ctx - The context object.
       */
    engine.onStateChange = function onStateChange() {
        if (window.location.hostname.match(/mobilereservations/)) { // Mobile
            thn.languageCheck().then(function ({ changed }) {
                if (!changed) {
                    thn.pageCheck();
                }
            });
        }
    };
    /**
       * @memberOf module:bs_86
       * @see {@link generate_search_url}
       *
       * @param {object} ctx - The context object.
       */
    engine.generateSearchUrl = function generateSearchUrl(ctx) {
        var url = new Url(ctx.baseUrl);
        var mobile = false;
        if (url.host.match(/myreservations.omnibees.com/) && url.query.CheckIn === '[date_begin]' && url.query.CheckOut === '[date_end]') {
            // Case 0: Valid URL.
            url.hash = ''; // Return an empty hash
            ctx.newUrl = url.decode(url.toString());
        }
        else if (url.host.match(/myreservations.omnibees.com/)) {
            // Case 1: Format Query Params
            url.query.CheckIn = '[date_begin]';
            url.query.CheckOut = '[date_end]';
            // delete hash
            url.hash = '';
            // export into ctx.new_url
            ctx.newUrl = url.decode(url.toString());
        }
        else if (url.host.match(/mobilereservations.omnibees.com/)
            && url.path.match(/\/searchDetails\//)) {
            // Case 2: Mobile version, just format URLs that match this pattern
            // Url: https://mobilereservations.omnibees.com/hotel/searchDetails/6352?CheckinFormatted=09-11-2018&CheckoutFormatted=10-11-2018&NumberRooms=1&NumberAdults=1
            mobile = true;
            url.query.CheckinFormatted = '[date_begin]';
            url.query.CheckoutFormatted = '[date_end]';
            // export into ctx.new_url
            ctx.newUrl = url.decode(url.toString());
        }
        else if (url.host.match(/book.omnibees/)) {
            // https://book.omnibees.com/hotelresults?c=1872&q=3073&hotel_folder=&NRooms=1&CheckIn=30072024&CheckOut=31072024&ad=2&ch=0&ag=&child_age_input=12&Code=&group_code=&loyalty_code=&lang=es-ES&currencyId=23&version=4
            ctx.newUrl = url.toString();
        }
        else {
            // Case 3: Not a valid URL. Return empty
            ctx.newUrl = '';
        }
        if (thn.empty(ctx.newData.dateBegin)
            || thn.empty(ctx.newData.dateEnd)) {
            // invalid
            ctx.newUrl = '';
        }
        else if (!mobile) {
            // Format of dates: yyyy/mm/dd -> ddmmyyyy
            ctx.newData.dateBegin = ctx.newData.dateBegin && ctx.newData.dateBegin.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3$2$1');
            ctx.newData.dateEnd = ctx.newData.dateEnd && ctx.newData.dateEnd.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3$2$1');
        }
        else {
            // Format of dates: yyyy/mm/dd -> dd-mm-yyyy
            ctx.newData.dateBegin = ctx.newData.dateBegin && ctx.newData.dateBegin.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3-$2-$1');
            ctx.newData.dateEnd = ctx.newData.dateEnd && ctx.newData.dateEnd.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3-$2-$1');
        }
        return ctx;
    };
    /**
       * @memberOf module:bs_86
       * @this thn.widgets.price
       * @see {@link Price#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        var $ = window.jQuery;
        var $content;
        var $loader;
        // do this just once
        if (thn.omnibeesUpdater) {
            return;
        }
        if (window.location.hostname.indexOf('mobilereservations.') === 0) { // Mobile
            if (!document.querySelector) {
                return;
            }
            const loader = document.querySelector('app-page-load-spinner .top');
            if (loader) {
                thn.data.omnibeesUpdaterLoading = thn.isVisible(loader);
                thn.omnibeesUpdater = thn.debounce(function thnOmnibeesUpdater() {
                    if (thn.isVisible(loader)) {
                        // Loading just show
                        thn.data.omnibeesUpdaterLoading = true;
                    }
                    else if (thn.data.omnibeesUpdaterLoading) {
                        // Loading just hide
                        thn.data.omnibeesUpdaterLoading = false;
                        thn.languageCheck().then(function ({ changed }) {
                            if (!changed) {
                                ctx.widget.refresh();
                            }
                        });
                    }
                });
                // Start observation
                thn.observeDom(loader, thn.omnibeesUpdater, {
                    childList: false,
                    subtree: false,
                    characterData: false,
                    attributes: true,
                    attributeFilter: ['class', 'style'],
                });
                // Stop observation on page unload
                thn.pageUnload(function () {
                    thn.stopObserveDom(loader, thn.omnibeesUpdater);
                    delete thn.omnibeesUpdater;
                    delete thn.data.omnibeesUpdaterLoading;
                    // Unload PW for proper loading when returning to R&R
                    ctx.widget.reset();
                });
            }
        }
        else if (window.location.hostname === 'm-reservations.omnibees.com') { // other mobile version
            if (!document.querySelector) {
                return;
            }
            const loader = document.querySelector('.ui-mobile');
            if (loader) {
                thn.omnibeesUpdater = thn.debounce(function thnOmnibeesUpdater() {
                    thn.omnibeesIsVisible = function () {
                        return loader.classList.contains('ui-loading');
                    };
                    if (thn.omnibeesIsVisible() && !thn.data.omnibeesUpdaterLoading) {
                        // Loading just show
                        thn.data.omnibeesUpdaterLoading = true;
                    }
                    else if (thn.data.omnibeesUpdaterLoading) {
                        // Loading just hide
                        thn.data.omnibeesUpdaterLoading = false;
                        thn.languageCheck().then(() => ctx.widget.refresh());
                    }
                }, 300);
                // Start observation
                thn.observeDom(loader, thn.omnibeesUpdater, {
                    childList: false,
                    subtree: false,
                    characterData: false,
                    attributes: true,
                    attributeFilter: ['class'],
                });
                // Stop observation on page unload
                thn.pageUnload(function () {
                    thn.stopObserveDom(loader, thn.omnibeesUpdater);
                    delete thn.omnibeesUpdater;
                    delete thn.data.omnibeesUpdaterLoading;
                    delete thn.omnibeesIsVisible;
                    // Unload PW for proper loading when returning to R&R
                    ctx.widget.reset();
                });
            }
        }
        else if (window.location.hostname.match(/book.omnibees.com/)) {
            // 04/2021 desktop version
            // Examples of pids that use this version at the time of writing: 1027114, 1027115
            // https://book.omnibees.com/chain/1557
            const main = document.querySelector('#step-results-center');
            if (main && !thn.omnibeesUpdater) {
                thn.omnibeesUpdater = thn.debounce(function thnOmnibeesUpdater() {
                    const loader = document.querySelector('.loading-wrapper');
                    function isLoading() {
                        return loader && thn.isVisible(loader);
                    }
                    if (!isLoading()) {
                        ctx.widget.logger.debug('*************** New search **************');
                        if (ctx.widget.refresh() && ctx.widget.isSet()) {
                            ctx.widget.hide();
                        }
                    }
                }, 300);
                // Start observation
                thn.observeDom(main, thn.omnibeesUpdater, {
                    childList: true,
                    subtree: false,
                    attributes: false,
                });
                // Stop observation on page unload
                thn.pageUnload(function () {
                    thn.stopObserveDom(main, thn.omnibeesUpdater);
                    delete thn.omnibeesUpdater;
                    delete thn.data.omnibeesUpdaterLoading;
                });
            }
        }
        else { // Desktop
            if (!$) {
                return;
            }
            thn.omnibeesUpdater = thn.debounce(function thnOmnibeesUpdater() {
                ctx.widget.logger.debug('*************** DOM Changed **************');
                ctx.widget.update();
            }, 600);
            $content = $('#content_loader');
            $loader = $('#preloader');
            if ($content.length) {
                // observe the content just for DIRECT child mutations, give 600ms of extra time to render
                thn.observeDom($content.get(0), thn.omnibeesUpdater, {
                    characterData: false,
                    subtree: false,
                });
            }
            if ($loader.length) {
                // observe preloader just for attr changes
                thn.observeDom($loader.get(0), thn.omnibeesUpdater, {
                    childList: false,
                    subtree: false,
                    characterData: false,
                    attributes: true,
                    attributeFilter: ['class', 'style'],
                });
            }
            const undelegateClick = thn.delegate('click', '#btnBook, #search, .maintable', ctx.widget.minimize);
            const undelegateFocus = thn.delegate('focus', '[name^=room_]', ctx.widget.minimize);
            thn.pageUnload(function () {
                undelegateClick();
                undelegateFocus();
                if ($content.length) {
                    thn.stopObserveDom($content.get(0), thn.omnibeesUpdater);
                }
                if ($loader.length) {
                    thn.stopObserveDom($loader.get(0), thn.omnibeesUpdater);
                }
                delete thn.omnibeesUpdater;
            });
        }
    };
    /**
       * @memberOf module:bs_86
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData_v1 = function priceParseData_v1(ctx) {
        var widgetData = {};
        if (window.location.hostname.match(/book.omnibees.com/)) {
            return widgetData;
        }
        // Include language data in the PW to influence refresh()
        widgetData.language = thn.data.language;
        if (window.location.hostname.indexOf('mobilereservations.') === 0) { // Mobile
            if (!document.querySelector || !document.querySelectorAll) {
                return widgetData;
            }
            // Dates and Rooms
            // Try to get the data from the JSON object
            try {
                const searchJson = JSON.parse(window.sessionStorage.getItem('BE_MOBILE.searchParams')).data;
                widgetData.dateBegin = thn.dateToString(searchJson.checkIn);
                widgetData.dateEnd = thn.dateToString(searchJson.checkOut);
                widgetData.rooms = parseInt(searchJson.nRooms, 10) || 1;
            }
            catch (err) {
                widgetData.dateBegin = thn.parseUrlParameter('CheckinFormatted').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
                widgetData.dateEnd = thn.parseUrlParameter('CheckoutFormatted').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
                widgetData.rooms = parseInt(thn.parseUrlParameter('NumberRooms'), 10) || 1;
            }
            // Guests
            widgetData.adults = parseInt(thn.parseUrlParameter('NumberAdults'), 10)
                || parseInt(thn.parseUrlParameter('ad'), 10)
                || 1;
            widgetData.children = parseInt(thn.parseUrlParameter('NumberChilds'), 10)
                || parseInt(thn.parseUrlParameter('ch'), 10)
                || 0;
            widgetData.guests = widgetData.adults + widgetData.children;
            // Currency
            widgetData.currency = engine._mobileGetCurrency();
            const pricesEl = document.querySelectorAll('.room .room-list .price');
            if (pricesEl.length > 0) {
                const prices = Array.from(pricesEl).map(function (el) {
                    return thn.parseNumber(el.textContent);
                });
                widgetData.price = Math.min(...prices);
                // Price per night
                if (widgetData.price && widgetData.dateBegin && widgetData.dateEnd) {
                    widgetData.price = Math.round((widgetData.price / thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd)) * 100) / 100;
                }
                widgetData.set = true;
            }
            else if (document.querySelector('.error-box')) {
                widgetData.noRooms = true;
            }
        }
        else if (window.location.hostname === 'm-reservations.omnibees.com') { // other mobile version
            // Guests Dates and Rooms
            const searchData = document.querySelector('#ViewSearchContentCriteria');
            if (searchData) {
                // Dates
                const datesEl = searchData.children[0];
                if (datesEl) {
                    const datesArr = datesEl.textContent.split('|');
                    // const dates_arr_formated = dates_arr.map(date => date.trim().split(' ').slice(2, date.length - 1).join(' '));
                    widgetData.dateBegin = translateDate(datesArr[0], thn.data.language);
                    widgetData.dateEnd = translateDate(datesArr[1], thn.data.language);
                }
                // Guests & Rooms
                const guestsEl = searchData.children[1];
                if (guestsEl) {
                    const guestsArr = guestsEl.textContent.split(',');
                    widgetData.adults = thn.parseNumber(guestsArr[2]) || 1;
                    widgetData.children = thn.parseNumber(guestsArr[3]) || 0;
                    widgetData.guests = widgetData.adults + widgetData.children;
                    widgetData.rooms = thn.parseNumber(guestsArr[1]) || 1;
                }
            }
            /* currency
                  This BE only features Brazil Real for now, if they add currencies to the drop down. Just
                  add it to the currencies object
                  */
            const currencies = {
                'Brazil Real': 'BRL',
            };
            const currencySelect = document.querySelector('#currency');
            if (currencySelect) {
                const currency = currencySelect.options[currencySelect.selectedIndex].textContent;
                widgetData.currency = currencies[currency];
            }
            // prices
            const priceEls = document.querySelectorAll('#price_1');
            if (priceEls.length > 0) {
                const pricesArr = [...priceEls].map((price) => thn.parseNumber(price.textContent)).filter((price) => price);
                widgetData.price = Math.min(...pricesArr);
                widgetData.set = true;
            }
            else {
                widgetData.noRooms = true;
            }
        }
        else {
            const $ = window.jQuery;
            if (!$) {
                return widgetData;
            }
            const prices = Array.from($('.item:not(.hiddenRates)')).map((el) => {
                if ($(el).find('.rateName').text().trim() !== 'ROOM OFFICE') {
                    return {
                        price: thn.parseNumber($(el)?.find('.price_tooltip')?.text()),
                    };
                }
                return null;
            }).filter(Boolean).sort((a, b) => a - b);
            const loaded = $('#preloader:visible').length === 0;
            if (loaded) {
                // Default values
                widgetData.adults = 2;
                widgetData.children = 0;
                const $info = $('#packageSearchParameters .info');
                if ($info.length) {
                    const replacement = thn.data.language === 'en' ? '$3/$1/$2' : '$3/$2/$1';
                    // Rooms
                    widgetData.rooms = 1;
                    // html version 1
                    if ($info.find('> span:eq(0)').length) {
                        const $infoSpan = $info.find('> span');
                        widgetData.dateBegin = $infoSpan.eq(0).clone().children().remove()
                            .end()
                            .text()
                            .trim()
                            .replace(/(\d+)\D+(\d+)\D+(\d+)/, replacement);
                        widgetData.dateEnd = $infoSpan.eq(1).clone().children().remove()
                            .end()
                            .text()
                            .trim()
                            .replace(/(\d+)\D+(\d+)\D+(\d+)/, replacement);
                        widgetData.adults = parseInt($infoSpan.eq($infoSpan.length - 2).clone().children().remove()
                            .end()
                            .text()
                            .trim(), 10) || 2;
                        widgetData.children = parseInt($infoSpan.eq($infoSpan.length - 1).clone().children().remove()
                            .end()
                            .text()
                            .trim(), 10) || 0;
                        // html version 2
                    }
                    else {
                        // Dates
                        widgetData.dateBegin = $info.find('.qs_checkin input').val().replace(/(\d+)\D+(\d+)\D+(\d+)/, replacement);
                        widgetData.dateEnd = $info.find('.qs_checkout input').val().replace(/(\d+)\D+(\d+)\D+(\d+)/, replacement);
                        // Guests
                        widgetData.adults = thn.parseNumber($info.find('.qs_NrAdults_label').text().trim()) || 2;
                        widgetData.children = thn.parseNumber($info.find('.qs_NrChildrens_label').text().trim()) || 0;
                    }
                }
                else {
                    // Dates
                    const dateBeginEl = document.querySelector('#inputCheckIn');
                    if (dateBeginEl) {
                        widgetData.dateBegin = thn.dateToString(dateBeginEl.value);
                    }
                    const dateEndEl = document.querySelector('#inputCheckOut');
                    if (dateEndEl) {
                        widgetData.dateEnd = thn.dateToString(dateEndEl.value);
                    }
                    // Rooms
                    const roomsEl = document.querySelector('#selectRooms');
                    if (roomsEl) {
                        widgetData.rooms = parseInt(roomsEl.value, 10) || 1;
                    }
                    // Guests
                    const adultsEl = document.querySelector('#selectAdults');
                    if (adultsEl) {
                        widgetData.adults = parseInt(adultsEl.value, 10) || 2;
                    }
                    const childrenEl = document.querySelector('#selectChildren');
                    if (childrenEl) {
                        widgetData.children = parseInt(childrenEl.value, 10) || 0;
                    }
                }
                widgetData.guests = widgetData.adults + widgetData.children;
                widgetData.rooms = 1;
                // Note: the only value in the select list is "Euro"
                // revisit this when adding hotels with more currencies
                // widgetData.currency = $('select#ddCurrency option:selected').text().substr(0, 3).toUpperCase();
                if (thn.empty(prices)) {
                    widgetData.noRooms = true;
                }
                else {
                    widgetData.price = prices[0];
                    // Note: second try with currency, revisit if it fails with USD or other mainstream symbols
                    widgetData.currency = thn.parseCurrency((document.querySelector('.price_tooltip') || '').text);
                    widgetData.set = true;
                }
            }
            else if (document.querySelector('.noResults')) {
                widgetData.noRooms = true;
            }
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_86
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData_v2 = function priceParseData_v2(ctx) {
        // 04/2021 desktop version
        // Examples of pids that use this version at the time of writing: 1027114, 1027115
        // https://book.omnibees.com/chain/1557
        const widgetData = {};
        const datalayer = window.dataLayer;
        if (!window.location.hostname.match(/book.omnibees.com/)) {
            return widgetData;
        }
        // DATES
        // Obtaining dates from query params in this format: '18052021' for '2021/05/18'
        const dateBeginEl = thn.parseUrlParameter('CheckIn') || document.querySelector('#date_from')?.value;
        const dateEndEl = thn.parseUrlParameter('CheckOut') || document.querySelector('#date_to')?.value;
        let dateBegin = dateBeginEl?.replace(/(\d{2})(\d{2})(\d{4})/, '$3/$2/$1');
        let dateEnd = dateEndEl?.replace(/(\d{2})(\d{2})(\d{4})/, '$3/$2/$1');
        if ((!dateBegin || !dateEnd) && datalayer) {
            dateBegin = (thn.objectGet(datalayer, 'checkIn'))?.replace(/(\d{4})(\d{2})(\d{2})/, '$1/$2/$3');
            dateEnd = (thn.objectGet(datalayer, 'checkOut'))?.replace(/(\d{4})(\d{2})(\d{2})/, '$1/$2/$3');
        }
        widgetData.dateBegin = dateBegin;
        widgetData.dateEnd = dateEnd;
        const nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
        // prices Elcielo Hotel
        const isElcieloHotel = thn.data.propertyId === 1035158;
        if (isElcieloHotel) {
            // currency
            const currency = document.querySelector('.currency_symbol_price.symbol_right')?.textContent;
            widgetData.currency = currency;
            const priceElcieloHotel = [...document.querySelectorAll('.price-after')];
            if (priceElcieloHotel.length > 0) {
                const pricesArr = priceElcieloHotel.map((price) => thn.parseNumber(price?.textContent)).filter(Boolean);
                widgetData.price = Math.min(...pricesArr) / nights;
                widgetData.set = true;
            }
            else {
                widgetData.noRooms = true;
            }
        }
        // OCCUPANCY
        let adults = thn.parseNumber(thn.parseUrlParameter('ad'));
        let children = thn.parseNumber(thn.parseUrlParameter('ch'));
        if (!adults && !children && datalayer) {
            adults = thn.parseNumber(thn.objectGet(datalayer, 'numberAdults'));
            children = thn.parseNumber(thn.objectGet(datalayer, 'numberChildren'));
        }
        widgetData.adults = adults || 2;
        widgetData.children = children || 0;
        widgetData.guests = widgetData.adults + widgetData.children;
        // roomsDispo
        if (widgetData.children) {
            // Obtaining childrenAges from query params in this format: '3;2;8' for [3,2,8]
            const childrenAgesString = thn.parseUrlParameter('ag');
            const childrenAges = (childrenAgesString && childrenAgesString.split(';')) || [];
            const room1Info = {
                adults: widgetData.adults,
                children: widgetData.children,
                childrenAges,
            };
            widgetData.roomsDispo = [room1Info];
        }
        // PRICE
        const pricesSelector = [...document.querySelectorAll('.price-and-button .price-total-bold, .price-and-button .price-after')];
        const prices = pricesSelector ? pricesSelector.map((price) => thn.parseNumber(price?.textContent)).filter(Boolean) : [];
        const currency = document.querySelector('#currencies')?.value?.match(/\((\w{3})\)/)?.[1] || thn.dataLayerHelper.get('ecommerce.currencyCode');
        const ratesCount = [...document.querySelectorAll('.rate_plan')].length;
        const ratesRestrictionCount = [...document.querySelectorAll('.restricted_text_holder')].length;
        const unavailableDatesEl = document.querySelector('.unavailable_dates');
        if (!thn.empty(prices) && currency && nights) {
            widgetData.price = Math.min(...prices) / nights;
            widgetData.currency = currency;
            widgetData.set = true;
            // If we have not obtained the prices and we detect that the rooms shown have a restriction, we store non-availability.
        }
        else if ((!widgetData.price && ratesCount && ratesCount - ratesRestrictionCount === 0) || unavailableDatesEl) {
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_86
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        var widgetData = {};
        if (window.location.hostname.indexOf('mobilereservations.') === 0) { // Mobile
            // Reservation data
            try {
                const reservationJson = JSON.parse(window.sessionStorage.getItem('BE_MOBILE.BOOK.LastReservation')).data.HotelReservationsType.HotelReservations[0];
                // Id
                widgetData.bookingId = reservationJson.UniqueID.ID;
                // Dates
                widgetData.dateBegin = thn.dateToString(reservationJson.RoomStaysType.RoomStays[0].RoomRates[0].EffectiveDate);
                widgetData.dateEnd = thn.dateToString(reservationJson.RoomStaysType.RoomStays[0].RoomRates[0].ExpireDate);
                // Price
                widgetData.price = parseFloat(reservationJson.ResGlobalInfo.Total.AmountAfterTax);
            }
            catch (err) {
                thn.logger.debug(err, '--- Error Getting Booking_id and Dates ---');
            }
            widgetData.currency = engine._mobileGetCurrency();
        }
        else if (window.location.hostname === 'm-reservations.omnibees.com') { // other mobile version
            let bookingEl = document.querySelector('.info-text');
            const iconConfirmed = document.querySelector('.icon-confirmed');
            // If booking is confirmed
            if (bookingEl && iconConfirmed) {
                // Booking ID
                bookingEl = bookingEl.textContent.split(/\s+/);
                const bookingId = bookingEl.filter((el) => /^RES\d+-\d+$/.test(el));
                widgetData.bookingId = bookingId[0];
                // Dates and guests
                const bookingData = document.getElementById('ViewSearchContentCriteria');
                if (bookingData) {
                    // Dates
                    const datesEl = bookingData.children[0];
                    if (datesEl) {
                        const datesArr = datesEl.textContent.split('|');
                        // const dates_arr_formated = dates_arr.map(date => date.trim().split(' ').slice(2, date.length - 1).join(' '));
                        widgetData.dateBegin = translateDate(datesArr[0], thn.data.language);
                        widgetData.dateEnd = translateDate(datesArr[1], thn.data.language);
                    }
                    // Guests & Rooms
                    const guestsEl = bookingData.children[1];
                    if (guestsEl) {
                        const guestsArr = guestsEl.textContent.split(',');
                        widgetData.adults = thn.parseNumber(guestsArr[2]) || 1;
                        widgetData.children = thn.parseNumber(guestsArr[3]) || 0;
                        widgetData.guests = widgetData.adults + widgetData.children;
                        widgetData.rooms = thn.parseNumber(guestsArr[1]) || 1;
                    }
                    // Price
                    const priceEl = document.getElementById('ViewReservationDetailContent');
                    if (priceEl) {
                        const priceEls = priceEl.children[0].children;
                        const price = thn.parseNumber(priceEls[priceEls.length - 1].children[0].textContent);
                        widgetData.price = price;
                        // esta version del BE solo tiene Brazil Real
                        widgetData.currency = 'BRL';
                    }
                }
            }
            else {
                widgetData.set = false;
                return widgetData;
            }
        }
        else if (window.location.hostname.match(/book.omnibees.com/)) {
            // 04/2021 desktop version
            // Examples of pids that use this version at the time of writing: 1027114, 1027115
            // https://book.omnibees.com/chain/1557
            // The booking confirmed page can be revisited by the user
            // however the window.body object is only present on first visit
            if (window.body) {
                // DATES
                // Obtaining dates from query params in this format: '18052021' for '2021/05/18'
                widgetData.dateBegin = (thn.parseUrlParameter('CheckIn') || '').replace(/(\d{2})(\d{2})(\d{4})/, '$3/$2/$1');
                widgetData.dateEnd = (thn.parseUrlParameter('CheckOut') || '').replace(/(\d{2})(\d{2})(\d{4})/, '$3/$2/$1');
                // PRICE
                const purchaseData = window.body?.ecommerce?.purchase?.actionField;
                const priceDl = thn.dataLayerHelper.get('ecommerce.value');
                const priceDom = document.querySelectorAll('.custom-room__row-room-total-value span span')[1]?.textContent;
                const currencyDom = thn.parseCurrency(document.querySelectorAll('.custom-room__row-room-total-value span span')[1]?.textContent);
                const currencyDl = thn.dataLayerHelper.get('ecommerce.currencyCode');
                widgetData.price = thn.parseNumber(priceDom) || priceDl;
                widgetData.currency = (priceDom && currencyDom) || (priceDl && currencyDl);
                // BOOKING ID
                widgetData.bookingId = purchaseData?.id || thn.dataLayerHelper.get('ecommerce.transaction_id');
                widgetData.promocode = purchaseData?.coupon || thn.dataLayerHelper.get('ecommerce.purchase.actionField.coupon');
            }
            else {
                ctx.widget.logger.debug('User revisiting booking page: not parsing booking data');
            }
        }
        else {
            const $ = window.jQuery;
            if (!$) {
                return widgetData;
            }
            const url = ($('.btn_extras > a').attr('onclick') || '').match(/\?[^'"]+/); // match the "search" part of the url
            if (url && thn.parseUrlParameter('CheckIn', url[0]) && thn.parseUrlParameter('CheckOut', url[0])) {
                widgetData.dateBegin = thn.parseUrlParameter('CheckIn', url[0]).replace(/(\d{2})(\d{2})(\d{4})/, '$3/$2/$1');
                widgetData.dateEnd = thn.parseUrlParameter('CheckOut', url[0]).replace(/(\d{2})(\d{2})(\d{4})/, '$3/$2/$1');
            }
            else {
                const replacement = thn.data.language === 'en' ? '$3/$1/$2' : '$3/$2/$1';
                widgetData.dateBegin = $('.checkin').text().replace(/(\d+)\D+(\d+)\D+(\d+)/, replacement);
                widgetData.dateEnd = $('.checkout').text().replace(/(\d+)\D+(\d+)\D+(\d+)/, replacement);
            }
            widgetData.price = thn.parseNumber($('#reservationTotal').text().trim())
                || parseFloat(window.reservationTotal);
            // Note: the only value in the select list is "Euro"
            // revisit this when adding hotels with more currencies
            widgetData.currency = $('select#ddCurrency option:selected').text().substr(0, 3).toUpperCase();
            // bookingId
            widgetData.bookingId = $('.reservationNumber > strong, .reservationNumber > span').eq(0).text().trim();
        }
        // corrections
        if (widgetData.currency === 'BRA') {
            widgetData.currency = 'BRL';
        }
        else if (widgetData.currency === 'COL') {
            widgetData.currency = 'COP';
        }
        return widgetData;
    };
    return engine;
}

export { factory };
